/* Tienda Novale – header behaviours.
   StickyHeader logic adapted from Dawn (MIT, Shopify Inc.). */

function tnSetHeaderHeight(header) {
  if (!header) return;
  document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
}

if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      const type = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = type === 'always' || type === 'reduce-logo-size';
      this.headerBounds = {};

      tnSetHeaderHeight(this.header);
      this.onMediaChange = () => tnSetHeaderHeight(this.header);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
      this.header.querySelectorAll('products-mega-menu').forEach((menu) => menu.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
}

if (!customElements.get('static-header')) {
  class StaticHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      tnSetHeaderHeight(this.header);
      window.matchMedia('(max-width: 990px)').addEventListener('change', () => tnSetHeaderHeight(this.header));
    }
  }
  customElements.define('static-header', StaticHeader);
}

/* Products & collections mega menu: opens on hover, the hovered collection shows its cards. */
if (!customElements.get('products-mega-menu')) {
  class ProductsMegaMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = this.querySelector('.products-mega-menu__body');
      this.overlay = this.querySelector('.products-mega-menu__overlay');
      this.items = Array.from(this.querySelectorAll('[data-mega-item]'));

      this.summary.addEventListener('mouseenter', () => this.open());
      if (this.overlay) {
        this.overlay.addEventListener('mouseenter', () => this.close());
        this.overlay.addEventListener('click', () => this.close());
      }
      this.items.forEach((item) => {
        const link = item.querySelector('a');
        const activate = () => this.activate(item);
        link.addEventListener('mouseenter', activate);
        link.addEventListener('focus', activate);
      });

      this.onDocumentClick = (event) => {
        if (this.details.hasAttribute('open') && !this.contains(event.target)) this.close();
      };
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    activate(item) {
      this.items.forEach((i) => i.classList.toggle('is-active', i === item));
    }

    open() {
      document
        .querySelectorAll('.header details[open]')
        .forEach((details) => details !== this.details && details.removeAttribute('open'));
      this.details.setAttribute('open', '');
    }

    close() {
      this.details.removeAttribute('open');
    }
  }
  customElements.define('products-mega-menu', ProductsMegaMenu);
}
